import { t } from '@lingui/macro';

import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { AdminPages, buildPageTarget } from '../AdminLinkUtils';
import { GROUPS_ADMIN_NAME_FIELD } from '../groups/GroupsAdminConstants';

export const DASHBOARDS_ADMIN_PRIVATE_FIELD = 'private';
export const DASHBOARDS_ADMIN_TITLE_FIELD = 'title';
export const DASHBOARDS_ADMIN_USERID_FIELD = 'userId';
export const DASHBOARDS_ADMIN_GROUPS_FIELD = 'groups';

export const getDashboardListColumns = (isSysAdmin) => [
    {
        type: COLUMN_TYPES.LINK,
        mapping: DASHBOARDS_ADMIN_TITLE_FIELD,
        title: t`Title`,
        width: 240,
        sortable: true,
        link: {
            sysAdminOnly: true,
            target: buildPageTarget(AdminPages.Dashboards),
        },
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'ownerUsername',
        title: t`Owner`,
        width: 200,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'groupNames',
        title: t`Groups`,
        width: 400,
        maxWidth: 800,
        formatter: (groupNames) => (groupNames ? groupNames.join(', ') : '--'),
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: DASHBOARDS_ADMIN_PRIVATE_FIELD,
        title: t`Private`,
        sortable: true,
        width: 120,
        formatter: (isPrivate) => (isPrivate ? t`Yes` : t`No`),
    },
    {
        type: COLUMN_TYPES.LINK,
        width: 120,
        sortable: false,
        formatter: () => t`View Dashboard`,
        hidden: !isSysAdmin,
        link: {
            sysAdminOnly: true,
            target: '/:_id',
        },
        uiOnly: true,
    },
];

export const DASHBOARD_SHARE_GROUPS_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        mapping: GROUPS_ADMIN_NAME_FIELD,
        title: t`Group Name`,
        width: 240,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'userCount',
        title: t`Members`,
        sortable: true,
        width: 460,
    },
];
